import React, { useState } from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { BASE_URL, BLACK, PRIMARY, WHITE } from "../../../appConstants";

const FlipkartGiveAccess = () => {
    // brand_id = '3bf4d01e-f71b-41c4-bbbc-78bd70d69d10' // xyxx
    const {brand_id} = useParams();
    const platform_id = '2b2c5687-6887-4f4c-9509-4abd7341b81e'; // flipkart
    const [selectedTab, setSelectedTab] = useState<string>("SELLER");
    const navigate = useNavigate();
    const location = useLocation();

    const tabs = [ 
        { id: "SELLER", name: "Seller", url: `/flipkartgiveAccess/seller` },
        { id: "SELLERADS", name: "Seller Ads", url: `/flipkartgiveAccess/SellerAds` },
        { id: "ADS", name: "Ads", url: `/flipkartgiveAccess/ads` },
    ];

    const onTabChange = (tab: string, url: string) => {
        setSelectedTab(tab);
        navigate(`${url}/${brand_id}`);
    }

  return (
        <div style={{ height: "calc(100vh - 72px)"}}>
          <div
            className="flex flex-row px-10"
            style={{
              height: 52,
              boxShadow: "0px 4px 10px 4px rgba(99, 99, 99, 0.05)",
            }}
          >

            {tabs.map((tab, i) => {
                return (
                  <div
                  onClick={() => onTabChange(tab.id, tab.url)}
                  key={tab.id}
                  className="p-4 cursor-pointer"
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: location.pathname.includes(tab.url) ? PRIMARY.P_BLue : BLACK.B_40,
                    borderBottom:
                      location.pathname.includes(tab.url) ? `2px solid ${PRIMARY.P_BLue}` : "",
                  }}
                >
                  {tab.name}
                </div>
              );
            })}
          </div>

          <div
            className=""
            style={{ height: "calc(100vh - 125px)" }}
          >
            <Outlet />
          </div>
        </div>
  )
}

export default FlipkartGiveAccess